module.exports = __webpack_public_path__ + "static/media/sustainthegrainLogo.41e48ee0.png";